<template>
  <div class="form-body">
    <div class="row">
      <div class="img-holder">
        <div class="bg" :style="bannerImages"></div>
        <div class="info-holder"></div>
      </div>
      <div class="form-holder">
        <div class="form-content">
          <div class="form-items">
            <span class="logo" v-html="logos"></span>
            <h3 class="login-welcome-back" style="margin-top: 15px;">Welcome to screenit</h3>
            <p style="text-align: center;margin-bottom: 10px;font-size: 14px">Sign Up to stay updated on all new world.</p>
            <div class="container">
              <b-form class="form-signup" v-on:submit.prevent="onSubmit" novalidate>
                <div class="form-label-group">
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Email"
                    v-model.lazy.trim="$v.form.user_email.$model"
                    :state="chkState('user_email')"
                    @keyup="changeEmail"
                    autofocus
                  />
                  <div v-if="$v.form.user_email.$error">
                    <p v-if="!$v.form.user_email.required" class="login-alert-msg error-content">* Enter your email</p>
                    <p v-if="!$v.form.user_email.email" class="login-alert-msg error-content">* Enter a valid email</p>
                  </div>
                  <div v-if="!$v.form.user_email.$error">
                    <p v-if="emailvalidate == 1" class="login-alert-msg error-content">* Enter your organization email</p>
                  </div>
                  <div v-if="errormsg == 'Email already exists'">
                    <p class="login-alert-msg error-content">* Email already exists</p>
                  </div>
                </div>
                <div class="form-label-group">
                  <vue-tel-input
                    class="form-control"
                    placeholder="Mobile Number"
                    @onInput="onInput"
                    v-bind:class="{ 'is-invalid': !isValiedmobileNumber }"
                    :state="chkState('mobile_number')"
                  ></vue-tel-input>
                  <div v-if="$v.form.mobile_number.$error">
                    <p v-if="!$v.form.mobile_number.required" class="login-alert-msg error-content">* Enter your mobile number</p>
                    <p v-if="!$v.form.mobile_number.minLength" class="login-alert-msg error-content">* Enter a valid mobile number</p>
                  </div>
                  <div v-if="!$v.form.user_email.$error">
                    <p v-if="errormsg == 'Email not exit!'" class="login-alert-msg error-content">* Mobile no already exists</p>
                  </div>
                </div>
                <button style="font-size: 16px;"
                  class="btn btn__large_coman_hight btn-lg btn-success btn-block"
                  type="submit"
                >Sign Up</button>
              </b-form>
              <!-- <p v-if="userStatus" class="login-alert-msg">Your email or password does not exit!</p> -->
              <!-- <center>
                <h2 align="center">
                  <span>or</span>
                </h2>
              </center> -->
            </div>
            <!-- <div class="row">
              <div class="col-sm-6">
                <button class="loginBtn loginBtn--google" @click="googleLogin">
                  <span class="fa fa-google"></span>
                  <img
                    style="width: 24px;margin-top: -5px;"
                    src="data:image/png;base64,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"
                  />
                  Login with Google
                </button>
              </div>
              <div class="col-sm-6">
                <button class="loginBtn loginBtn--facebook" @click="linkedInSignin">
                  <svg
                    width="20"
                    height="20"
                    style="margin-top: -8px;"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      x="0.78418"
                      y="0.745094"
                      width="18.4314"
                      height="18.4314"
                      fill="url(#pattern0)"
                    />
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use xlink:href="#image0" transform="scale(0.00390625)" />
                      </pattern>
                      <image
                        id="image0"
                        width="256"
                        height="256"
                        xlink:href="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                  Sign in with Linkedin
                </button>
              </div>
            </div> -->
            <h3 class="new_to_screenit">
              Already have an account?
              <span class="form-join-now cursor-usage" @click="userLogin">Sign In</span>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import { VueTelInput } from 'vue-tel-input'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
import Vue from 'vue'
import bannerImage from '../../assets/img/login-image.jpg'
import { logo } from '../../shared/svg'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

export default {
  name: 'Registration',
  components: {
    VueTelInput
  },
  data () {
    return {
      form: {
        user_email: '',
        mobile_number: '',
        organizationStatus: 'organization'
      },
      bannerImages: `background-image: url(${bannerImage})`,
      password: null,
      password_length: 0,
      typed: false,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      hasError: false,
      userStatus: false,
      currentModel: '',
      paswordStrength: 0,
      isValiedmobileNumber: true,
      organizationTypeSelected: true,
      logos: logo,
      errormsg: '',
      emailvalidate: 0
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      user_email: {
        required,
        email
      },
      mobile_number: {
        required,
        // maxLength: maxLength(12),
        minLength: minLength(10)
      },
      organizationStatus: {}
    }
  },
  created () {
    localStorage.removeItem('_verification')
    localStorage.setItem('setPassword', JSON.stringify(false))
  },
  methods: {
    changeEmail () {
      console.log(this.form.user_email)
      const email = this.form.user_email
      const str = email.split('@')
      this.emailvalidate = 0
      console.log(str)
      if (str[1] === 'gmail.com' || str[1] === 'Gmail.com' || str[1] === 'yahoo.com' || str[1] === 'Yahoo.com') {
        this.emailvalidate = 1
      } else {
        this.emailvalidate = 0
      }
    },
    clearmsg () {
      this.errormsg = ''
    },
    onInput ({ number, isValid, country }) {
      console.log(this.form)
      console.log(isValid)
      console.log(country)
      this.isValiedmobileNumber = isValid
      this.form.mobile_number_country_code = country.dialCode
      this.form.mobile_number = number.significant
    },
    selectOrganizationTypes (value) {
      if (value === 'individual') {
        this.organizationTypeSelected = true
        this.form.organizationStatus = 'individual'
      } else {
        this.organizationTypeSelected = false
        this.form.organizationStatus = 'organization'
      }
    },
    onSubmit () {
      console.log(this.isValiedmobileNumber)
      if (this.validate()) {
        this.$nextTick(() => {
          if (this.emailvalidate === 1) {
            return false
          }
          if (this.isValiedmobileNumber) {
            const data = {
              user_email: this.form.user_email.toLowerCase(),
              mobile_number: this.form.mobile_number,
              organizationStatus: this.form.organizationStatus,
              mobile_number_country_code: this.form.mobile_number_country_code
            }
            axios
              .post(BaseURL + '/email/create/user/using/email', {
                formData: data
              })
              .then(response => {
                this.errormsg = response.data.message
                if (response.data.userDetails.user_email === data.user_email) {
                  localStorage.setPassword = true
                  router.push({ name: 'registeration-complete' })
                } else {
                  this.currentModel = this.form.user_email
                  this.userStatus = true
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            this.isValiedmobileNumber = false
          }
        })
      } else {
        this.isValiedmobileNumber = false
        console.log('else................')
      }
    },
    userLogin () {
      router.push({ name: 'Login' })
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some(child => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  }
}
</script>

<style scoped>
.form-control input {
    height: 27px !important;
}
.register____user__type {
  color: #000000;
  width: 44%;
  border: 1px solid #5bad2b;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}
.is______active {
  background-color: #5bad2b;
  color: #fff;
}
.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
/* input:focus,
select:focus {
  border: 1px solid #4dbd74;
} */

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
}

.form-content input[type="checkbox"]:not(:checked) + label,
.form-content input[type="checkbox"]:checked + label,
.form-content input[type="radio"]:not(:checked) + label,
.form-content input[type="radio"]:checked + label {
  color: #000 !important;
}

select {
  appearance: none !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  position: relative;
  background: 0 0;
  z-index: 10;
  cursor: pointer;
}

.select-icon {
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.select-icon i {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  width: 40px;
  height: 20px;
  font-size: 18px;
  color: #999;
}
.form-content {
    width: 65%;
}
@media (max-width: 992px){
  .form-holder .form-content {
      padding: 30px 0px;
  }
}
.container {
    width: 100% !important;
}
input {
  height: 27px !important;
}
.vue-tel-input {
  padding: 0px !important;
}
.form-items {
  margin-top: 12% ;
}
.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
h2 {
  width: 60%;
  text-align: center;
  border-bottom: 1px solid #7b7373;
  line-height: 0.1em;
  margin: 10px 0 20px;
  font-size: 18px;
}
h2 span {
  background: #f5f5f5;
  padding: 0 10px;
}

.container {
    width: 100% !important;
}
.error-content {
  float: left !important;
  margin-bottom: 2px !important;
}
.ie {
  margin-top: 9px !important;
}
.form-label-group {
  position: relative;
  margin-bottom: 2rem;
}

</style>
